let gridColumn;
class collectionPage {
    constructor(){
       document.querySelectorAll("[data-per-row]").forEach(ele=>{
          ele.addEventListener("click",(event)=>{
            event.preventDefault();
            this._changeGridItems(event);
          });
       })
    };

    _changeGridItems(event){
       let currentElement = event.currentTarget;
       document.querySelectorAll("[data-per-row]").forEach(ele=>{
        ele.classList.remove("filter-active");
       });
       currentElement.classList.add("filter-active");
       let columnCount =  currentElement.getAttribute("data-per-row");
       columnCount = parseInt(columnCount);
       gridColumn = columnCount;
       if (columnCount == 2) {
        document.querySelectorAll("[data-product-handle]").forEach(ele=>{
            if(ele.classList.contains("medium-up--one-third") || ele.classList.contains("medium-up--one-quarter")){
                ele.classList.remove("medium-up--one-third");
                ele.classList.remove("medium-up--one-quarter");
                ele.classList.add("medium-up--one-half");
            }
        });
       }else if (columnCount == 3){
        document.querySelectorAll("[data-product-handle]").forEach(ele=>{
            if(ele.classList.contains("medium-up--one-quarter") || ele.classList.contains("medium-up--one-half")){
                ele.classList.remove("medium-up--one-quarter");
                ele.classList.remove("medium-up--one-half");
                ele.classList.add("medium-up--one-third");
            }
        })
       }else if (columnCount == 4){
        document.querySelectorAll("[data-product-handle]").forEach(ele=>{
            if(ele.classList.contains("medium-up--one-half") || ele.classList.contains("medium-up--one-third")){
                ele.classList.remove("medium-up--one-half");
                ele.classList.remove("medium-up--one-third");
                ele.classList.add("medium-up--one-quarter");
            }
        })
       }
    }
}
   
new collectionPage()